import { AnyDoc } from "@megaron/docs-contracts";

const invoiceDraftEmptyNameFallback = "Wersja robocza";

const isInvoiceDraftDoc = (doc: AnyDoc): boolean => doc.docId.startsWith("invoice-draft:");

export const getDocDisplayName = (doc: AnyDoc): string => {
  const name = doc.name ?? "";

  if (isInvoiceDraftDoc(doc) && name.trim().length === 0) {
    return invoiceDraftEmptyNameFallback;
  }

  return name;
};
